import { render, staticRenderFns } from "./dealer-data-details.vue?vue&type=template&id=6cf17249&scoped=true&"
import script from "./dealer-data-details.vue?vue&type=script&lang=js&"
export * from "./dealer-data-details.vue?vue&type=script&lang=js&"
import style0 from "./dealer-data-details.vue?vue&type=style&index=0&id=6cf17249&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf17249",
  null
  
)

export default component.exports